
import { toString } from "../../fable_modules/fable-library-js.5.3.0/Date.js";
import { printf, toText } from "../../fable_modules/fable-library-js.5.3.0/String.js";
import { HtmlHelper_createElement } from "../../fable_modules/Feliz.3.3.3/Html.fs.js";
import { margin_mb4, padding_p6, boxShadow_shadow, borderRadius_roundedLg, margin_mb6, gap_gap$002D2, display_inlineFlex, fontSize_textSm, fontSize_textBase, alignItems_itemsCenter, display_flex, fontWeight_fontSemibold, fontSize_textLg, display_block, width_wFull, backgroundColor_bgNeutral200, gap_gap$002D4, display_grid, tw } from "../../fable_modules/Feliz.Tailwind.4.0.2/Strings.fs.js";
import { TailwindHelpers_linkPrimary, TailwindHelpers_cardHover } from "../Layout/Layout.js";
import { isEmpty, ofArray, singleton } from "../../fable_modules/fable-library-js.5.3.0/List.js";
import { backgroundColor_bgSurface, textColor_textNeutral800, textColor_textNeutral700, textColor_textNeutral900, FocusVisible_ring, textColor_textNeutral500, backgroundColor_bgWarning50, borderColor_borderWarning300, md } from "../TailwindExtensions.js";
import { sectionError, skeletonLine, skeletonHeading } from "../Layout/Interactions.js";
import { op_Division, op_Multiply, min, toInt32, fromParts, compare } from "../../fable_modules/fable-library-js.5.3.0/Decimal.js";
import { map, empty, singleton as singleton_1, append, delay, toList } from "../../fable_modules/fable-library-js.5.3.0/Seq.js";
import { ClientTypes_Msg, ClientTypes_Route } from "../ClientTypes.js";
import { createElement } from "react";
import { IconWeight, IconSize, IconName, icon } from "../Icons.js";
import { defaultOf } from "../../fable_modules/fable-library-js.5.3.0/Util.js";
import { value as value_58 } from "../../fable_modules/fable-library-js.5.3.0/Option.js";
import { categorize } from "./PledgeCategorization.js";

function formatDate(date) {
    return toString(date, "MMM d, yyyy");
}

function formatCurrency(amount) {
    return toText(printf("$%.2f"))(amount);
}

function skeletonCard() {
    return HtmlHelper_createElement("div", ofArray([["className", tw(singleton(TailwindHelpers_cardHover))], ["children", [HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_grid, md("grid-cols-2"), gap_gap$002D4]))], ["children", [HtmlHelper_createElement("div", ofArray([["className", tw(singleton("space-y-3"))], ["children", [skeletonHeading(50), skeletonLine(75), skeletonLine(66)]]])), HtmlHelper_createElement("div", ofArray([["className", tw(singleton("space-y-3"))], ["children", [skeletonLine(50), skeletonLine(100), skeletonLine(33)]]]))]]]))]]]));
}

function loadingView() {
    return HtmlHelper_createElement("div", ofArray([["aria-busy", true], ["className", tw(singleton("space-y-4"))], ["children", [skeletonCard(), skeletonCard(), skeletonCard()]]]));
}

function progressBar(unitsCompleted, goalUnits) {
    return HtmlHelper_createElement("progress", ofArray([["max", 100], ["value", (compare(goalUnits, fromParts(0, 0, 0, false, 0)) > 0) ? ~~toInt32(min(fromParts(100, 0, 0, false, 0), op_Multiply(op_Division(unitsCompleted, goalUnits), fromParts(100, 0, 0, false, 0)))) : 0], ["className", tw(ofArray(["h-3", "appearance-none", backgroundColor_bgNeutral200, "rounded-full", width_wFull, "[&::-webkit-progress-bar]:bg-neutral-200", "[&::-webkit-progress-bar]:rounded-full", "[&::-webkit-progress-value]:bg-primary-600", "[&::-webkit-progress-value]:rounded-full", "[&::-webkit-progress-value]:transition-all", "[&::-moz-progress-bar]:bg-primary-600", "[&::-moz-progress-bar]:rounded-full", "[&::-moz-progress-bar]:transition-all"]))]]));
}

function pledgeCard(pledge, category, dispatch) {
    let arg_2;
    const ch = pledge.Challenge;
    const isUnfulfilled = category === "unfulfilled";
    const isPast = category === "past";
    const cardClasses = tw(toList(delay(() => append(singleton_1(TailwindHelpers_cardHover), delay(() => append(singleton_1(display_block), delay(() => append(singleton_1("cursor-pointer"), delay(() => (isUnfulfilled ? append(singleton_1("border-l-4"), delay(() => append(singleton_1(borderColor_borderWarning300), delay(() => singleton_1(backgroundColor_bgWarning50))))) : empty()))))))))));
    const textMuted = isPast ? textColor_textNeutral500 : "";
    const stretchedLink = HtmlHelper_createElement("a", ofArray([["href", toText(printf("/pledges/%s"))(pledge.PledgeId)], ["className", tw(ofArray(["absolute", "inset-0", FocusVisible_ring]))], ["aria-label", ch.Title], ["onClick", (e) => {
        e.preventDefault();
        dispatch(new ClientTypes_Msg(37, [new ClientTypes_Route(10, [pledge.PledgeId])]));
    }]]));
    return HtmlHelper_createElement("article", ofArray([["className", tw(ofArray(["relative", cardClasses]))], ["children", [stretchedLink, HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_grid, md("grid-cols-2"), gap_gap$002D4]))], ["children", [HtmlHelper_createElement("div", ofArray([["className", tw(singleton("space-y-2"))], ["children", [HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([fontSize_textLg, fontWeight_fontSemibold, textColor_textNeutral900, textMuted]))], ["children", singleton(ch.Title)]])), HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, alignItems_itemsCenter, "gap-1.5", fontSize_textBase, textColor_textNeutral700, textMuted]))], ["children", [createElement(icon, {
        name: new IconName(3, []),
        size: new IconSize(0, []),
        weight: new IconWeight(0, []),
    }), HtmlHelper_createElement("span", singleton(["children", singleton(ch.CharityName)]))]]])), HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, alignItems_itemsCenter, "gap-1.5", fontSize_textBase, textColor_textNeutral700, textMuted]))], ["children", [createElement(icon, {
        name: new IconName(43, []),
        size: new IconSize(0, []),
        weight: new IconWeight(0, []),
    }), HtmlHelper_createElement("span", singleton(["children", singleton(toText(printf("Hosted by %s"))(ch.HostName))]))]]])), HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textNeutral500]))], ["children", singleton((arg_2 = formatDate(pledge.CreatedAt), toText(printf("Pledged %s"))(arg_2)))]]))]]])), HtmlHelper_createElement("div", ofArray([["className", tw(singleton("space-y-2"))], ["children", toList(delay(() => {
        let arg_3, arg_5;
        return append(singleton_1(HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([fontSize_textBase, textColor_textNeutral700, textMuted]))], ["children", singleton((arg_3 = formatCurrency(pledge.AmountPerUnit), (arg_5 = (pledge.CapAtGoal ? " (capped)" : ""), toText(printf("%s per %s%s"))(arg_3)(ch.UnitName)(arg_5))))]]))), delay(() => append(singleton_1(progressBar(ch.UnitsCompleted, ch.GoalUnits)), delay(() => append(singleton_1(HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textNeutral500]))], ["children", singleton(toText(printf("%.0f / %.0f %s completed"))(ch.UnitsCompleted)(ch.GoalUnits)(ch.UnitName))]]))), delay(() => {
            let matchValue, amt, arg_9;
            return append((matchValue = pledge.PledgedAmount, (matchValue == null) ? (empty()) : ((amt = matchValue, singleton_1(HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([fontSize_textBase, fontWeight_fontSemibold, textColor_textNeutral700, textMuted]))], ["children", singleton((arg_9 = formatCurrency(amt), toText(printf("Estimated: %s"))(arg_9)))]])))))), delay(() => {
                let link;
                const matchValue_1 = pledge.DonateLink;
                let matchResult, link_1;
                if (matchValue_1 != null) {
                    if ((link = matchValue_1, isUnfulfilled)) {
                        matchResult = 0;
                        link_1 = matchValue_1;
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
                switch (matchResult) {
                    case 0:
                        return singleton_1(HtmlHelper_createElement("a", ofArray([["href", link_1], ["target", "_blank"], ["rel", "noopener noreferrer"], ["className", tw(ofArray([TailwindHelpers_linkPrimary, display_inlineFlex, alignItems_itemsCenter, "gap-1.5", "relative", "z-[1]"]))], ["children", [createElement(icon, {
                            name: new IconName(34, []),
                            size: new IconSize(0, []),
                            weight: new IconWeight(1, []),
                        }), "Donate now", createElement(icon, {
                            name: new IconName(48, []),
                            size: new IconSize(0, []),
                            weight: new IconWeight(0, []),
                        })]]])));
                    default: {
                        return empty();
                    }
                }
            }));
        }))))));
    }))]]))]]]))]]]));
}

function pledgeSection(title, iconName, category, pledges, dispatch) {
    if (isEmpty(pledges)) {
        return defaultOf();
    }
    else {
        return HtmlHelper_createElement("div", ofArray([["className", tw(singleton("mb-6"))], ["children", [HtmlHelper_createElement("h3", ofArray([["className", tw(ofArray([display_flex, alignItems_itemsCenter, gap_gap$002D2, fontSize_textLg, fontWeight_fontSemibold, textColor_textNeutral800, "mb-4"]))], ["children", [createElement(icon, {
            name: iconName,
            size: new IconSize(1, []),
            weight: new IconWeight(0, []),
        }), title]]])), HtmlHelper_createElement("div", ofArray([["className", tw(singleton("space-y-4"))], ["children", toList(delay(() => map((p) => pledgeCard(p, category, dispatch), pledges)))]]))]]]));
    }
}

/**
 * Main MyPledges view component
 */
export function view(model, dispatch) {
    const matchValue = model.Auth;
    switch (matchValue.tag) {
        case 1:
            if (model.LoadingMyPledges) {
                return HtmlHelper_createElement("div", ofArray([["className", tw(singleton(margin_mb6))], ["children", [loadingView()]]]));
            }
            else if (model.MyPledgesError != null) {
                return HtmlHelper_createElement("div", ofArray([["className", tw(singleton(margin_mb6))], ["children", [sectionError(value_58(model.MyPledgesError), () => {
                    dispatch(new ClientTypes_Msg(87, []));
                })]]]));
            }
            else {
                const matchValue_1 = model.MyPledges;
                if (matchValue_1 != null) {
                    if (isEmpty(matchValue_1)) {
                        const pledges_1 = matchValue_1;
                        return defaultOf();
                    }
                    else {
                        const pledges_2 = matchValue_1;
                        const categorized = categorize(pledges_2);
                        return HtmlHelper_createElement("div", ofArray([["data-testid", "dashboard-pledges-section"], ["className", tw(ofArray([backgroundColor_bgSurface, borderRadius_roundedLg, boxShadow_shadow, padding_p6]))], ["children", [HtmlHelper_createElement("h3", ofArray([["className", tw(ofArray([display_flex, alignItems_itemsCenter, gap_gap$002D2, fontSize_textLg, fontWeight_fontSemibold, textColor_textNeutral900, margin_mb4]))], ["children", [createElement(icon, {
                            name: new IconName(3, []),
                            size: new IconSize(1, []),
                            weight: new IconWeight(0, []),
                        }), "My Pledges"]]])), pledgeSection("Action Needed", new IconName(34, []), "unfulfilled", categorized.Unfulfilled, dispatch), pledgeSection("Active Pledges", new IconName(4, []), "active", categorized.Active, dispatch), pledgeSection("Past Pledges", new IconName(47, []), "past", categorized.Past, dispatch)]]]));
                    }
                }
                else {
                    return defaultOf();
                }
            }
        default:
            return defaultOf();
    }
}

//# sourceMappingURL=MyPledgesView.js.map
